import {
  ApiLocationFleet,
  LocationFleet,
  TabItem,
  AccountLocation,
  Address,
  DropdownItem,
} from "../types";
import { AccountModel } from "./AccountModel";

export class LocationModel {
  public static buildLocations(
    locations: AccountLocation[],
  ): AccountLocation[] {
    return locations.map((location) => ({
      locationNumber: location.locationNumber,
      locationName: location.locationName,
      addressLine1: location.addressLine1,
      addressLine2: location.addressLine2,
      city: location.city,
      state: location.state,
      country: location.country,
      zip: location.zip,
      email: location.email || "N/A",
      website: location.website || "N/A",
      contactPerson: location.contactPerson || "N/A",
      instruction: location.instruction || "N/A",
    }));
  }

  public static buildLocationFleets(
    accountFleets: ApiLocationFleet[],
  ): LocationFleet[] {
    return accountFleets.map((accountLocationFleet) => ({
      location: {
        name: accountLocationFleet.locationName,

        number: accountLocationFleet.locationNumber,
      },
      fleets: AccountModel.buildFleetsInfo(accountLocationFleet.fleets),
    }));
  }

  public static buildLocationsTab(
    locations: { locationNumber: number; locationName: string }[],
  ): TabItem[] {
    return locations.map((location) => ({
      key: location.locationName,
      value: location.locationNumber,
    }));
  }

  public static getAddressLabel(
    address: Pick<
      Address,
      "addressLine1" | "addressLine2" | "city" | "state" | "zip"
    >,
  ): string {
    return [
      address.addressLine1,
      address.addressLine2,
      address.city,
      [address.state, address.zip].filter(Boolean).join(" "),
    ]
      .filter(Boolean)
      .join(", ");
  }

  public static parseAddressLabel(
    address: string,
    statesDropdown: DropdownItem[],
  ): Required<
    Pick<Address, "addressLine1" | "addressLine2" | "city" | "state" | "zip">
  > {
    const parts = address.split(", ");
    const [state, ...zip] = parts[parts.length - 1].split(" ");
    const isFormatted =
      parts.length >= 3 &&
      zip.length > 0 &&
      statesDropdown.some((item) => item.value === state);

    if (!isFormatted) {
      return {
        addressLine1: address,
        addressLine2: "",
        city: "",
        state: "",
        zip: "",
      };
    }

    return {
      addressLine1: parts[0],
      addressLine2: parts.slice(1, -2).join(", "),
      city: parts[parts.length - 2],
      state,
      zip: zip.join(" "),
    };
  }

  public static buildAddressDropdown(
    locations: AccountLocation[],
  ): DropdownItem[] {
    return locations.map((location) => {
      const address = LocationModel.getAddressLabel(location);

      return { key: `${location.locationName} – ${address}`, value: address };
    });
  }

  public static buildLocationDropdown(
    locations: { locationNumber: number; name: string }[],
  ): DropdownItem[] {
    return locations.map((location) => ({
      key: location.name,
      value: location.locationNumber,
    }));
  }
}
